// reducers.js
import { SET_DECK_ID } from './actions';

const initialState = {
  deckId: '',
};

const deckIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DECK_ID:
      return {
        ...state,
        deckId: action.payload,
      };
    default:
      return state;
  }
};

export default deckIdReducer;
